import { render } from "./AddParametre.vue?vue&type=template&id=227233e9&scoped=true&ts=true"
import script from "./AddParametre.vue?vue&type=script&lang=ts"
export * from "./AddParametre.vue?vue&type=script&lang=ts"

import "./AddParametre.vue?vue&type=style&index=0&id=227233e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227233e9"]])

export default __exports__